import { useToast } from "@src/appV2/lib";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useCallback } from "react";

import { useCreateUnlockRequest } from "./useCreateUnlockRequest";

export function UnlockRequestButton() {
  const worker = useDefinedWorker();
  const { showErrorToast } = useToast();
  const {
    mutateAsync: createUnlockRequest,
    isLoading,
    isSuccess,
  } = useCreateUnlockRequest(worker.userId);

  const handleIveDoneThis = useCallback(async () => {
    try {
      await createUnlockRequest();
    } catch {
      showErrorToast("Something went wrong. Please try again.");
    }
  }, [createUnlockRequest, showErrorToast]);

  return (
    <LoadingButton
      fullWidth
      variant="contained"
      size="small"
      startIconType="checkmark"
      disabled={isSuccess}
      isLoading={isLoading}
      onClick={handleIveDoneThis}
    >
      {isSuccess ? "Unlock Request Sent" : "I've Done This"}
    </LoadingButton>
  );
}
